import { c as _c } from "react/compiler-runtime";
import { CicStatement } from "@/entities/IProfile";
export default function UserPageHeaderAboutStatement(t0) {
  const $ = _c(3);
  const {
    statement
  } = t0;
  if (!statement) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-text-sm tw-italic">Click to add an About statement</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== statement.statement_value) {
    t1 = <div className="tw-mb-0 tw-text-iron-200 tw-text-sm sm:tw-text-base tw-font-normal tw-whitespace-pre-line">{statement.statement_value}</div>;
    $[1] = statement.statement_value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}